// Product type constants
export const PRODUCT_TYPES = {
    TYPE_SINGLE_ROOM: 1,
    TYPE_BUNDLE: 2,
    TYPE_GIFT_VOUCHER: 3
};

export default {
    PRODUCT_TYPES
}; 